export default __webpack_public_path__ + "static/aiperi-cf71ed6777ad001b545055c8b72427a9.jpg";